import flagAT from '@/images/icons/flags/flag-at.svg'
import flagBE from '@/images/icons/flags/flag-be.svg'
import flagDE from '@/images/icons/flags/flag-de.svg'
import flagDK from '@/images/icons/flags/flag-dk.svg'
import flagEE from '@/images/icons/flags/flag-ee.svg'
import flagES from '@/images/icons/flags/flag-es.svg'
import flagFI from '@/images/icons/flags/flag-fi.svg'
import flagFR from '@/images/icons/flags/flag-fr.svg'
import flagGB from '@/images/icons/flags/flag-gb.svg'
import flagIE from '@/images/icons/flags/flag-ie.svg'
import flagIT from '@/images/icons/flags/flag-it.svg'
import flagLU from '@/images/icons/flags/flag-lu.svg'
import flagNL from '@/images/icons/flags/flag-nl.svg'
import flagNO from '@/images/icons/flags/flag-no.svg'
import flagPT from '@/images/icons/flags/flag-pt.svg'
import flagSE from '@/images/icons/flags/flag-se.svg'
import flagUS from '@/images/icons/flags/flag-us.svg'

import type {CountryCode} from '@/locale/locales'

export const countryFlags: Record<CountryCode, string> = {
    gb: flagGB,
    us: flagUS,
    dk: flagDK,
    ee: flagEE,
    es: flagES,
    fr: flagFR,
    de: flagDE,
    se: flagSE,
    ie: flagIE,
    at: flagAT,
    fi: flagFI,
    be: flagBE,
    nl: flagNL,
    it: flagIT,
    pt: flagPT,
    no: flagNO,
    lu: flagLU,
}
